import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Irradiacao } from 'src/app/models/irradiacao';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { GraficoService } from 'src/app/services/grafico.service';
import { IbgeService } from 'src/app/services/ibge.service';
import { IrradiacaoService } from 'src/app/services/irradiacao.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ValorGraficoDashboard } from 'src/app/models/dashboard';

@Component({
  selector: 'app-irradiacao-modal',
  templateUrl: './irradiacao-modal.component.html',
  styleUrls: ['./irradiacao-modal.component.scss']
})
export class IrradiacaoModalComponent implements OnInit {
  carregando = false;
  meses: any;
  dados: ValorGraficoDashboard[] = [];
  irradiacoes: Irradiacao[] = [];
  // options
  showXAxis = false;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = false;
  xAxisLabel = 'Country';
  showYAxisLabel = true;
  cidade;
  uf;

  colorScheme = {
    domain: ['#016db2']
  };

  constructor(private globalService: GlobalService, private ibgeService: IbgeService, private carregandoService: CarregandoService,
    private irradiacaoService: IrradiacaoService, private notificacaoService: NotificacaoService, private graficoService: GraficoService, public dialogRef: MatDialogRef<IrradiacaoModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private utilitarioService: UtilitarioService) {
    this.meses = data.meses;
    this.cidade = data.cidade;
    this.uf = data.uf;
  }

  ngOnInit(): void {
    setTimeout(() => {
      for (let x = 0; x < 12; x++) {
        this.dados.push({ id: x, name: this.utilitarioService.retornaNomeMes(x + 1, true), value: this.meses[x] });
      }
      this.dados = [...this.dados];
    }, 100);


  }

  fechar() {
    this.dialogRef.close();
  }

}
